// document ready
jQuery(document).ready(function ($) {

    // add rel noopener to external _blank links
    // https://gist.github.com/JamoCA/80f65eb07f054b1326221bd4f15868d6
    (function sanitizeExternalLinks() {
        $('a[target="_blank"]').each(function () {
            var a = $(this);
            if (location.hostname !== this.hostname) {
                var originalRel = (this.rel === undefined) ? '' : this.rel.toLowerCase();
                var newRel = originalRel.split(' ');
                if (originalRel.indexOf('noopener') === -1) {
                    newRel.push('noopener');
                }
                if (originalRel.indexOf('noreferrer') === -1) {
                    newRel.push('noreferrer');
                }
                if (originalRel.indexOf('nofollow') === -1) {
                    newRel.push('nofollow');
                }
                a.attr('rel', newRel.join(' ').trim());
            }
        });
    })();

    // ---------------------------------------------------------------------
    // | common shop elements                                              |
    // ---------------------------------------------------------------------

    // cookie disclaimer
    (function () {
        if ($('.jsCookieDisclaimer').length > 0) {
            if (localStorage.getItem('cookieDisclaimer') == null) {
                $('.jsCookieDisclaimer').fadeIn();
            }
            localStorage.setItem('cookieDisclaimer', 'seen');

            $('.jsBtnCookieDisclaimer').on('click', function (e) {
                e.preventDefault();
                if (window.localStorage) {
                    localStorage.setItem('cookieDisclaimer', 'seen');
                    $('.jsCookieDisclaimer').fadeOut();
                } else {
                    $('.jsCookieDisclaimer').fadeOut();
                }
            });
        }
    }());

    // quick categories menu
    (function () {
        // accordion trigger
        $('.jsQuickCategoriesToggle').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $('.jsQuickCategoriesWrap').stop(true).slideToggle();
        });
    }());

    // view all products on product category listing
    (function () {
        $('.jsBtnViewMoreProductList').on('click', function (e) {
            e.preventDefault();
            $(this)
				.parent('.btnViewMoreContainer')
				.addClass('hidden');
            $(this)
				.parent()
				.prev('.shopSubCategoryProductList')
				.addClass('active');
            var $thisCarousel = $(this).parents('.carousel');
            setTimeout(function () {
                $thisCarousel.flickity('resize');
            }, 100);
            $thisCarousel.find('.carouselCell').css('height', 'auto');
            $(window).resize();
        });
    })();
    // click to increase/decrease quantity field
    (function () {
        var timerid;
        var $increaseBtns = $('.jsIncrease');
        var $decreaseBtns = $('.jsDecrease');
        var $increaseQtyBtns = $('.jsIncreaseCartQty');
        var $decreaseQtyBtns = $('.jsDecreaseCartQty');
        var $quantityInput = $('.jsInputNumber');
        var onCartPage = $('.cartList').length;

        // increase
        $increaseBtns.on('click', function () {
            var $inputField = $(this).closest('.jsInputWrapper').find('.jsInputNumber');
            var $oldValue = $inputField.val();
            var $newVal = parseFloat($oldValue) + 1;
            $inputField.val($newVal);
        });

        // decrease
        $decreaseBtns.on('click', function () {
            var $inputField = $(this).closest('.jsInputWrapper').find('.jsInputNumber');
            var $oldValue = $inputField.val();
            var $newVal;
            if ($oldValue > 0) {
                $newVal = parseFloat($oldValue) - 1;
            }
            if ($newVal == 0) {
                $newVal = 1;
            }
            $inputField.val($newVal);
        });

        // increase qty in cart
        $increaseQtyBtns.on('click', function () {
            clearTimeout(timerid);
            timerid = setTimeout(function () {
                updateCartBase();
            }, 700);
        });

        // decrease qty in cart
        $decreaseQtyBtns.on('click', function () {
            clearTimeout(timerid);
            timerid = setTimeout(function () {
                updateCartBase();
            }, 700);
        });

        $quantityInput.on('input', function (e) {
            var value = $(this).val();
            // prevent negative values
            value = Math.abs(value);

            $(this).closest('.jsInputWrapper').find('input').val(value);

            // updateCartBase() if the value changed from its previous value on the cart page only
            if (value >= 1 && onCartPage > 0) {
                if (value != '' && value != '0' && $(this).data('lastval') != value) {
                    $(this).data('lastval', value);
                    clearTimeout(timerid);

                    timerid = setTimeout(function () {
                        updateCartBase();
                    }, 500);
                }
            }

            // prevent 0 values
            if (value == 0) {
                $(this).data('lastval', 1);
                $(this).val('1');
            }
        });
    })();

    // ---------------------------------------------------------------------
    // | yshop product category                                             |
    // ---------------------------------------------------------------------

    // creating custom scrollbar if the category listing exists, overwritten in css overrides.
    (function () {
        if ($('.shopSubCategoryProductList').length) {
            $('.shopSubCategoryProductList').mCustomScrollbar({
                theme: "dark"
            });
        }
    })();

    // ---------------------------------------------------------------------
    // | yshop product filtering                                            |
    // ---------------------------------------------------------------------
    function generateFilter(oldText) {
        $.ajax({
            type: 'POST',
            url: '/api/sitecore/product/GenerateProductFilterData',
            data: {
                SelectedProductGroup: $('.jsFilterProductGroup').val(),
                SelectedProductType: $('.jsFilterProductType').val(),
                SelectedModel: $('.jsFilterProductModel').val(),
                SelectedYear: $('.jsFilterProductYear').val()
            },
            success: function (response) {

                $('.jsBtnFilterProducts').prop('disabled', true);  //only false when year downdown has value (i.e all four dropdown have values)

                if (response.SubCategoryList !== null) {
                    $('.jsFilterProductType').attr('disabled', false);
                    $('.jsFilterProductType').empty();
                    $('.jsFilterProductType').append(new Option("Please Choose", ""));


                    $.each(response.SubCategoryList, function (index, value) {
                        $('.jsFilterProductType').append(new Option(value.Text, value.Value));
                    });
                    if (response.SelectedProductType != null) {
                        $('.jsFilterProductType').val(response.SelectedProductType);
                    }
                }

                if (response.ModelList !== null) {
                    $('.jsFilterProductModel').attr('disabled', false);
                    $('.jsFilterProductModel').empty();

                    $('.jsFilterProductModel').append(new Option("Please Choose", ""));
                    $.each(response.ModelList, function (index, value) {
                        $('.jsFilterProductModel').append(new Option(value.Text, value.Value));
                    });
                    if (response.SelectedModel != null) {
                        $('.jsFilterProductModel').val(response.SelectedModel);
                    }
                }

                if (response.YearList !== null) {
                    $('.jsFilterProductYear').attr('disabled', false);
                    $('.jsFilterProductYear').empty();

                    $('.jsFilterProductYear').append(new Option("Please Choose", ""));
                    $.each(response.YearList, function (index, value) {
                        $('.jsFilterProductYear').append(new Option(value.Text, value.Value));
                    });
                    if (response.SelectedYear != null) {
                        $('.jsFilterProductYear').val(response.SelectedYear);
                    }
                }

                $('.jsBtnFilterProducts').html(oldText);
                $('.jsFilterUrl').val(response.FilterUrl);
            }
        });
    }

    $('.jsApplyFilterProductGroup').on('change', function () {
        var oldText = $('.jsBtnFilterProducts').html();
        $('.jsBtnFilterProducts').html('loading...');

        $('.jsFilterProductType').attr('disabled', true);
        $('.jsFilterProductModel').attr('disabled', true);
        $('.jsFilterProductYear').attr('disabled', true);

        $('.jsFilterProductType').empty();
        $('.jsFilterProductModel').empty();
        $('.jsFilterProductYear').empty();

        if ($('.jsFilterProductGroup').val() != '') {
            generateFilter(oldText);
        }
        else {
            $('.jsFilterProducts').prop('disabled', true);
        }
    });

    $('.jsApplyFilterProductType').on('change', function () {
        var oldText = $('.jsBtnFilterProducts').html();
        $('.jsBtnFilterProducts').html('loading...');

        $('.jsFilterProductModel').empty();
        $('.jsFilterProductYear').attr('disabled', true);
        $('.jsFilterProductYear').empty();

        if ($('.jsFilterProductType').val() != '') {
            generateFilter(oldText);
        }
    });

    $('.jsApplyFilterProductModel').on('change', function () {
        var oldText = $('.jsBtnFilterProducts').html();
        $('.jsBtnFilterProducts').html('loading...');

        $('.jsFilterProductYear').attr('disabled', true);
        $('.jsFilterProductYear').empty();

        if ($('jsFilterProductModel').val() != '') {
            generateFilter(oldText);
        }
    });

    $('.jsFilterProductYear').on('change', function () {
        $('.jsBtnFilterProducts').attr('disabled', false);
    });

    $('.jsBtnFilterProducts').click(function () {

        var oldText = $('.jsBtnFilterProducts').html();
        $('.jsBtnFilterProducts').html('loading...');
        setTimeout(function () {
            $('.jsBtnFilterProducts').html(oldText);
        }, 3000);   //to handle user click back button from listing page

        //append year as query param if apply
        if ($('.jsFilterProductYear').length && $('.jsFilterProductYear').val() != '' && $('.jsFilterProductYear').val() != null) {
            window.location = $('.jsFilterUrl').val() + '?f=YearModel%3D' + $('.jsFilterProductYear').val();
        }
        else {
            window.location = $('.jsFilterUrl').val();
        }
    });

    // ---------------------------------------------------------------------
    // | yshop product listing                                             |
    // ---------------------------------------------------------------------

    function sortByFilter() {
        var e = document.getElementById('sortFilter');
        var sortOption = e.options[e.selectedIndex].value;

        window.location = updateQueryStringParameter(window.location.href, 'sortFilter', sortOption);
    }

    function updateQueryStringParameter(uri, key, value) {
        var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        var separator = uri.indexOf('?') !== -1 ? '&' : '?';
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + '=' + value + '$2');
        } else {
            return uri + separator + key + '=' + value;
        }
    }

    function postfacet(url) {
        var filterselection = '';
        var pageSizeSelection = '';
        var existingFilterSelection = [];

        $('input:checkbox[id^="filter_"]:checked').each(function () {
            var keyName = $(this).attr('name').replace('filter_', '');

            if (keyName in existingFilterSelection) {
                existingFilterSelection[keyName] = existingFilterSelection[keyName] + ',' + $(this).attr('value');
            } else {
                existingFilterSelection[keyName] = $(this).attr('value');
            }
        });

        $('select[id^="filter_"]').each(function () {
            var keyName = $(this).attr('name').replace('filter_', '');

            existingFilterSelection[keyName] = $(this).val();
        });

        for (var key in existingFilterSelection) {
            filterselection += key + '=' + existingFilterSelection[key] + '&';
        }

        if (getQueryStringValue('pgSz') != null) {
            pageSizeSelection = 'pgSz=' + getQueryStringValue('pgSz');
        }

        if (url == undefined) {
            url = window.location.href;
        }

        if (filterselection !== '') {
            if (getQueryStringValue('f') != null) {
                var queryStringToken = parseQueryStringToDictionary(decodeURIComponent(getQueryStringValue('f')));
                if (queryStringToken['sort'] != undefined) {
                    filterselection += 'sort=' + queryStringToken['sort'] + '&'; // sortOption is part of the filter
                }
            }

            filterselection = encodeURIComponent(filterselection.substring(0, filterselection.lastIndexOf('&')));
            window.location = url.split('?')[0].replace('#', '') + '?f=' + filterselection + '&' + pageSizeSelection;
        } else {
            window.location = url.split('?')[0].replace('#', '') + '?' + pageSizeSelection;
        }
    }

    function removeFilter(filternameValue) {
        // console.log(filternameValue.split('___').length);

        if (filternameValue.split('___').length == 2) {
            var filterName = 'filter_' + filternameValue.split('___')[0];
            var filterValue = filternameValue.split('___')[1];
            var nodeType = document.getElementById(filterName).nodeName;

            if (nodeType == 'INPUT') {
                $('input[type="checkbox"][id="' + filterName + '"][value="' + filterValue + '"]').attr('checked', false);
            } else if (nodeType == 'SELECT') {
                $('select[id="' + filterName + '"]').prop('selectedIndex', null);
            }
            postfacet();
        }
    }

    function getQueryStringValue(key) {
        return decodeURIComponent(
			window.location.search.replace(new RegExp('^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1')
		);
    }

    function parseQueryStringToDictionary(queryString) {
        var dictionary = {};

        // remove the '?' from the beginning of the
        // if it exists
        if (queryString.indexOf('?') === 0) {
            queryString = queryString.substr(1);
        }

        // step 1: separate out each key/value pair
        var parts = queryString.split('&');

        for (var i = 0; i < parts.length; i++) {
            var p = parts[i];
            // step 2: split key/value pair
            var keyValuePair = p.split('=');

            // step 3: add key/value pair to dictionary object
            var key = keyValuePair[0];
            var value = keyValuePair[1];

            // decode URI encoded string
            value = decodeURIComponent(value);
            value = value.replace(/\+/g, ' ');

            if (!(key in dictionary)) {
                // only handle one query string value
                dictionary[key] = value;
            }
        }

        // step 4: return dictionary object
        return dictionary;
    }

    // store link to local storage when click on product
    $('.jsProductThumb').on('click', function () {
        localStorage.setItem("lastProductCategory", window.location.href.split('?')[0]);
        window.location = $(this).attr("href");
        event.preventDefault();
    });

    // apply SubCategory
    $('.jsApplySubCategory').on('change', function () {
        postfacet($('#cboSubCategory').val());
    });

    // apply Product Model
    $('.jsApplyProductModel').on('change', function () {
        postfacet($('#cboProductModel').val());
    });

    // clear Product Model
    $('.jsRemoveProductModel').on('click', function () {
        postfacet($('#cboSubCategory').val());
    });

    // apply filter
    $('.jsApplyFilter').on('click', function () {
        postfacet();
    });

    // apply filter when clicking checkboxes
    $('.jsApplyFilterCheck').on('ifChanged', function () {
        postfacet();
    });

    // apply filter when changing dropdowns
    $('.jsApplyFilterDropdown').on('change', function () {
        postfacet();
    });

    // remove filter
    $('.jsRemoveFilter').on('click', function () {
        removeFilter($(this).data('filtername'));
    });

    // remove specific filter
    $('.jsRemoveSpecificFilter').on('click', function () {
        $('input:checkbox[id^="' + $(this).data('filtername') + '"]:checked').each(function () {
            $(this).prop('checked', false);
        });

        $('select[id^="' + $(this).data('filtername') + '"]').each(function () {
            $(this).prop('selectedIndex', null);
        });

        postfacet();
    });

    // remove all filters
    $('.jsRemoveAllFilter').on('click', function () {
        $('input:checkbox[id^="filter_"]:checked').each(function () {
            $(this).prop('checked', false);
        });

        $('select[id^="filter_"]').each(function () {
            $(this).prop('selectedIndex', null);
        });

        postfacet();
    });

    // toggle category browser & filter menus
    (function () {
        var $toggleCategoryBrowserButton = $('#btnToggleCategoryBrowser');
        var $toggleFiltersButton = $('#btnToggleFiltersShop');
        // only one can be open at a time due to tablet layout
        $toggleCategoryBrowserButton.on('click', function () {
            $toggleFiltersButton.parent().removeClass('active');
            $('.filtersShopListContainer').stop(true).slideUp();
            $toggleCategoryBrowserButton.parent().toggleClass('active');
            $('.categoryBrowserListContainer').stop(true).slideToggle();
        });
        $toggleFiltersButton.on('click', function () {
            $toggleCategoryBrowserButton.parent().removeClass('active');
            $('.categoryBrowserListContainer').stop(true).slideUp();
            $toggleFiltersButton.parent().toggleClass('active');
            $('.filtersShopListContainer').stop(true).slideToggle();
        });
        // collapse menus when entering tablet or mobile
        enquire.register('screen and (min-width: 768px)', {
            match: function () {
                $('#btnToggleCategoryBrowser, #btnToggleFiltersShop').parent().removeClass('active');
                $('.filtersShopListContainer, .categoryBrowserListContainer').stop(true).hide();
            }
        });
        enquire.register('screen and (max-width: 767px)', {
            match: function () {
                $('#btnToggleCategoryBrowser, #btnToggleFiltersShop').parent().removeClass('active');
                $('.filtersShopListContainer, .categoryBrowserListContainer').stop(true).hide();
            }
        });
        enquire.register('screen and (max-width: 1068px)', {
            match: function () {
                $('#btnToggleCategoryBrowser, #btnToggleFiltersShop').parent().removeClass('active');
                $('.filtersShopListContainer, .categoryBrowserListContainer').attr('style', '');
            }
        });
    })();

    // toggle filter groups
    (function () {
        var $toggleFilterGroupButtons = $('.jsBtnToggleFiltersGroup');
        $toggleFilterGroupButtons.on('click', function () {
            $(this).toggleClass('active');
            $(this).next('.filtersShop').stop(true).slideToggle();
        });
    })();

    // more filters button
    (function () {
        var $showMoreFiltersButtons = $('.jsBtnMoreFilters');
        $showMoreFiltersButtons.on('click', function () {
            var $this = $(this);
            $this.toggleText('More', 'Less');
            $this.toggleClass('active');
            $this.parent('.filtersShop').toggleClass('active');
        });
    })();

    // more filters button category product listing
    (function () {
        var $showMoreFiltersButtons = $('.jsBtnMoreFiltersCategory');
        $showMoreFiltersButtons.on('click', function () {
            var $this = $(this);
            $this.toggleText('More', 'Less');
            $this.toggleClass('active');
            $this.prev().toggleClass('active');
        });
    })();

    // truncate product listing description
    (function () {
        $('.jsProductListingList').each(function () {
            var $this = $(this);
            var $item = $this.find('.jsPanelProduct');
            var maxLength = $this.data('max-length');
            var maxLengthLessOne = maxLength - 1;
            $item.each(function () {
                var $stringContainer = $(this).find('.jsTruncate');
                var stringText = $stringContainer.text();
                if (stringText.length > maxLengthLessOne) {
                    stringText = stringText.substring(0, maxLength);
                    $stringContainer.html(stringText + '&hellip;');
                }
            });
        });
    })();

    // category panels
    (function () {
        $('.jsPanelMobileTrigger').click(function () {
            var $this = $(this);
            $this.closest('.panelShopSubCategory').find('.panelShopSubCategoryInner').slideToggle();
        });
    })();

    // show more button
    (function () {
        $('body').on('click', '.jsBtnMoreTableRows', function () {
            var $this = $(this);
            var $container = $(this).prev();
            $this.toggleText('Show More', 'Show Less');
            $this.toggleClass('active');
            $container.toggleClass('inactive');
        });
    })();

    // go back into history button used on error page
    (function () {
        $('body').on('click', '.jsBtnGoBack', function () {
            window.history.back();
        });
    })();

    // show more container
    (function () {
        var $showMoreContainer = $('.jsShowMoreContainer');
        $showMoreContainer.each(function () {
            var $index = 0;
            $(this).find('dt').each(function () {
                $index++;
                if ($index > 7) {
                    $(this).addClass('extra-row');
                    $(this).next().addClass('extra-row');
                }
            });
            if ($index > 7) {
                $(this).after('<button type="button" class="btnMoreFilters btnMoreRows jsBtnMoreTableRows">Show more</button>');
            }
        });
    })();

    // ---------------------------------------------------------------------
    // | yshop product detail                                              |
    // ---------------------------------------------------------------------

    $('.jsBtnProductNotification').on('click', function (e) {
        //check if email is valid
        if ($('#customerEmail').length && !/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test($('#customerEmail').val().toLowerCase())) {
            $('#productNotificationInvalidEmailBlock').show();
        }
        else {
            $.ajax({
                type: 'POST',
                url: '/api/sitecore/product/AddProductNotification',
                data: {
                    ProductCode: $('#productCode').val(),
                    CustomerEmail: $('#customerEmail').val(),
                    IsVariantProduct: $('#isVariantProduct').val(),
                    ProductUrl: $('#productUrl').val()
                },
                success: function (response) {
                    $('#productNotificationSubmitBlock').hide();
                    $('#productNotificationInvalidEmailBlock').hide();
                    $('#productNotificationMessageBlock').show();
                }
            });
        }
    });

    $('.jsBtnAddToCartModal').on('click', function (e) {
        $('.popup-modal').magnificPopup({
            type: 'inline',
            modal: true
        }).magnificPopup('open');

        $(document).on('click', '.jsBtnDismiss', function (e) {
            e.preventDefault();
            $.magnificPopup.close();
        });
    });

    $('.jsBtnAddToCart').on('click', function (e) {
        var btn = $(this);

        $('.alertSuccess').addClass('hidden');

        var categoryLink = localStorage.getItem("lastProductCategory");

        var productLink = window.location.href.split('?')[0];
        var productCartQuantity = 0;

        productLink = productLink.substring(1, productLink.lastIndexOf('/'));

        if ($('#variantId').val()) {
            productLink = productLink.substring(1, productLink.lastIndexOf('/'));
        }

        // if no value then add the current product detail
        if (!categoryLink) {
            localStorage.setItem("lastProductCategory", productLink);
        }

        $.ajax({
            type: 'POST',
            url: '/api/sitecore/cart/GetItemCartQuantity',
            data: {
                ProductId: $('#productId').val(),
                VariantId: $('#variantId').val(),
                Quantity: $('#quantity').val()
            },
            success: function (response) {
                if (response.Status == '200') {
                    productCartQuantity = response.Quantity;
                }

                $.ajax({
                    type: 'POST',
                    url: '/api/sitecore/cart/CheckGuestLogin',
                    success: function () {
                        if ((parseInt($('#quantity').val()) + productCartQuantity) > parseInt($('#maxLimit').val())) {
                            $('#maxLimitMessage').removeClass('hidden');
                        } else {
                            $.ajax({
                                type: 'POST',
                                url: '/api/sitecore/cart/AddToCart',
                                data: {
                                    ProductId: $('#productId').val(),
                                    VariantId: $('#variantId').val(),
                                    Quantity: $('#quantity').val()
                                },
                                success: function (response) {
                                    if (response.Status == '200' && response.CartPageUrl != '') {

                                        window.dataLayer = window.dataLayer || [];

                                        var currencyStr = "'" + $('.jsAddToCartCurrencyJson').val() + "'";

                                        if (typeof jsAddToCartJsonGA4 !== 'undefined') {

                                            dataLayer.push({
                                                'event': 'add_to_cart',
                                                'ecommerce':
                                                {
                                                    'currency': currencyStr,
                                                    'value': $('.jsAddToCartProductPriceJson').val(),
                                                    'items': [jsAddToCartJsonGA4]

                                                }
                                            });
                                        }


                                        window.location = response.CartPageUrl;

                                        $('#cannotPurchaseMessage').addClass('hidden');
                                    } else {
                                        $('#cannotPurchaseMessage').removeClass('hidden');
                                        $('#cannotPurchaseMessage > div').html("<p>" + response.Description + "</p>");
                                    }
                                }
                            });
                            e.preventDefault();
                        }
                    }
                });


            }
        });
    });

    if ($(".jsAddCartSuccessToggle").length) {
        $('.utilityNav .y-shop .btnUtilityCart').trigger('click');
    }

    if ($(".jsUserDuplicateError").length) {
        $('#formSubmitButton').removeAttr('disabled');
    }

    // yshop redesign 2019 - carousel featured products
    // carousel on mobile, turns into a grid on tablet and desktop
    // removed november 2020 https://switchit.atlassian.net/browse/YSSLA-762
    // (function() {
    // 	if ($('.carouselFeaturedProducts').length) {
    // 		enquire.register('screen and (max-width: 767px)', {
    // 			match: function() {
    // 				$('.carouselFeaturedProducts').flickity({
    // 					cellAlign: 'left',
    // 					contain: true
    // 				});
    // 				$(window).resize();
    // 			}
    // 		});

    // 		enquire.register('screen and (min-width: 768px)', {
    // 			match: function() {
    // 				if($('.carouselFeaturedProducts.flickity-enabled')) {
    // 					$('.carouselFeaturedProducts').flickity('destroy');
    // 				}
    // 			}
    // 		});
    // 	}
    // })();

    // product details main carousel & modal
    (function () {

        // product gallery
        var $productGalleryCarousel = $('#productGallery').flickity({
            arrowShape: {
                x0: 10,
                x1: 60, y1: 50,
                x2: 75, y2: 35,
                x3: 40
            },
            adaptiveHeight: true,
            autoPlay: false,
            cellAlign: 'left',
            cellSelector: '.carouselCell',
            contain: true,
            imagesLoaded: true,
            prevNextButtons: false,
            pageDots: false
        });

        // flickity instance
        var flkty = $productGalleryCarousel.data('flickity');
        var $thumbs = $('#productGalleryThumbs');
        var $thumbButtons = $('#productGalleryThumbs .button');

        // update selected thumb
        $productGalleryCarousel.on('select.flickity', function () {
            $thumbButtons.filter('.active').removeClass('active');
            $thumbButtons.eq(flkty.selectedIndex).addClass('active');
        });

        // select slide when clicking thumb
        $thumbs.on('click', '.button', function () {
            var index = $(this).index();
            $productGalleryCarousel.flickity('select', index);
        });

        // disable click during drag
        $productGalleryCarousel.on('dragStart.flickity', function (event, pointer) {
            $(this).addClass('is-dragging');
        });

        $productGalleryCarousel.on('dragEnd.flickity', function (event, pointer) {
            $(this).removeClass('is-dragging');
        });

        // initialise magnific popup
        $('#productGallery').magnificPopup({
            delegate: '.carouselLink',
            type: 'image',
            closeMarkup: '<button class="mfp-close">close</button>',
            preload: [0, 1],
            image: {
                verticalFit: true
            },
            zoom: {
                enabled: true
            },
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0, 1]
            }
        });

    })();

    // display [show all images] button if there are 5 or more images
    (function () {
        var $thumbAmount = $('#productGalleryThumbs .button').length;
        var $showAllButton = $('#btnShowAllImages');
        if ($thumbAmount > 4 && !$showAllButton.hasClass('hidden')) {
            $showAllButton.attr('style', '');
        }
    })();

    // [show all images] button
    (function () {
        $('#btnShowAllImages').on('click', function () {
            $('#productGalleryThumbs').addClass('open');
            $(this).addClass('hidden');
            return false;
        });
    })();

    // move add to cart tools between mobile/desktop
    (function () {
        if ($('#ctnProductToolsMobile').length) {
            var $defaultLoc = $('#ctnProductToolsMobile');
            var $secondLoc = $('#ctnProductToolsDesktop');
            var $element = $('#productCartTools');
            enquire.register('screen and (min-width: 768px)', {
                match: function () {
                    $secondLoc.append($element);
                },
                unmatch: function () {
                    $defaultLoc.append($element);
                }
            });
        }
    }());

    // move add to cart tools between mobile/desktop
    (function () {
        if ($('.jsProductRefine').length) {
            var $defaultLoc = $('.jsProductRefine');
            var $secondLoc = $('.jsProductRefineDesktop');
            var $element = $('.jsProductRefineForm');
            enquire.register('screen and (min-width: 768px)', {
                match: function () {
                    $secondLoc.append($element);
                },
                unmatch: function () {
                    $defaultLoc.append($element);
                }
            });
        }
    }());

    // move meta & social elements
    (function () {
        if ($('#productMetaSocialContainer').length) {
            var $anchorElement = $('#productNamePrice');
            var $element = $('#productMetaSocialContainer');
            enquire.register('screen and (min-width: 1068px)', {
                match: function () {
                    $element.insertBefore($anchorElement);
                },
                unmatch: function () {
                    $element.insertAfter($anchorElement);
                }
            });
        }
    }());

    // ----------------------------------------------
    // variant filter                               |
    // ----------------------------------------------

    function postVariantFilter(keyValuePair) {
        var filterselection = '';

        $('.productRefine input:radio[id^="variantFilter_"]:checked').each(function () {
            var keyName = $(this).attr('name').replace('variantFilter_', '');
            filterselection += keyName + '=' + $(this).attr('value') + '&';
        });

        $('.productRefine select[id^="variantFilter_"]').each(function () {
            var keyName = $(this).attr('name').replace('variantFilter_', '');
            if ($(this).val() != '') {
                filterselection += keyName + '=' + $(this).val() + '&';
            }
        });

        filterselection = encodeURIComponent(filterselection.substring(0, filterselection.lastIndexOf('&')));
        encodeKeyValuePair = encodeURIComponent(keyValuePair);
        window.location = window.location.href.split('?')[0].replace('#', '') + '?f=' + filterselection + '&kp=' + encodeKeyValuePair;

        // console.log(window.location.href.split('?')[0].replace('#', '') + '?f=' + filterselection + '&kp=' + encodeKeyValuePair);
    }

    $('.jsApplyVariantFilterRadio').on('ifChecked', function (event) {
        var key = $(this).attr('id');
        var keyValue = $(this).attr('value');
        var keyValuePair = key.replace('variantFilter_', '') + '=' + keyValue;
        if (keyValue != null && keyValue != '') {
            postVariantFilter(keyValuePair);
        }
    });

    $('.jsApplyVariantFilterDropdown').on('select2:select', function (event) {
        var key = $(this).attr('id');
        var keyValue = $(this).val();
        var keyValuePair = key.replace('variantFilter_', '') + '=' + keyValue;
        if (keyValue != null && keyValue != '') {
            postVariantFilter(keyValuePair);
        }
    });

    $('.jsProductRefine select').select2({
        templateResult: function (data, container) {
            if (data.element) {
                $(container).addClass($(data.element).attr('class'));
            }
            return data.text;
        }
    });


    // ---------------------------------------------------------------------
    // | account pages                                                     |
    // ---------------------------------------------------------------------

    // select country to update state
    (function () {

        // billing
        var countrySelect = $('select[name=' + 'BillingCountry' + ']');
        var stateSelect = $('select[name=' + 'BillingState' + ']');

        autoUpdateState(countrySelect, stateSelect);

        // shipping
        var countrySelect = $('select[name=' + 'ShippingCountry' + ']');
        var stateSelect = $('select[name=' + 'ShippingState' + ']');

        autoUpdateState(countrySelect, stateSelect);

        function autoUpdateState(countrySelect, stateSelect) {
            countrySelect.on('change', function () {
                var country = $(this).val();
                setStateStatus(country, stateSelect);
            });

            if (stateSelect.children('option').length == 1) {
                stateSelect.prop('disabled', true);
            }
        }

        function setStateStatus(country, state) {
            if (country != '') {
                $.ajax({
                    url: '/api/region/' + country
                }).done(function (data) {
                    state.empty();
                    if (data.length > 0) {
                        state.append(
							$('<option>', {
							    value: '',
							    text: '-- Please Select --'
							})
						);
                        $(data).each(function () {
                            var val = this;
                            state.append(
								$('<option>', {
								    value: val,
								    text: val
								})
							);
                        });
                        state.parent().removeClass('disabled');
                        state.removeAttr('disabled');
                        var label = state.parent();
                        if (!label.hasClass('required')) {
                            state.parent().addClass('required');
                        }
                    } else {
                        state.prop('disabled', true);
                        state.parent().removeClass('required');
                        state.parent().addClass('disabled');
                    }
                });
            } else {
                state.parent().removeClass('required');
                state.parent().addClass('disabled');
                state.prop('disabled', true);
            }
        }
    })();


    // side nav
    (function () {
        // accordion trigger
        $('.jsSideNavToggle').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $('.jsSideNavWrap').stop(true).slideToggle();
        });
    })();

    // tile sublink separators
    (function () {
        $('.jsTileSublinkItem').each(function () {
            if ($(this).siblings('.jsTileSublinkItem')) {
                $(this).addClass('hasSibling');
            }
        });
    })();

    // add class to last row of products
    (function () {
        var $productItems = $('.productListingList > li');
        var $productCount = $productItems.length;

        function resetItems() {
            $productItems.removeClass('lastRow');
        }

        // 2 columns
        enquire.register('screen and (max-width: 767px)', {
            match: function () {
                resetItems();
                var $modulus = $productCount % 2;
                if ($modulus == 0) {
                    $productItems.slice(-2).addClass('lastRow');
                } else {
                    $productItems.slice(0 - $modulus).addClass('lastRow');
                }
            }
        });
        // 3 columns
        enquire.register('screen and (min-width: 768px) and (max-width: 1067px)', {
            match: function () {
                resetItems();
                var $modulus = $productCount % 3;
                if ($modulus == 0) {
                    $productItems.slice(-3).addClass('lastRow');
                } else {
                    $productItems.slice(0 - $modulus).addClass('lastRow');
                }
            }
        });
        // 4 columns
        enquire.register('screen and (min-width: 1069px)', {
            match: function () {
                resetItems();
                var $modulus = $productCount % 4;
                if ($modulus == 0) {
                    $productItems.slice(-4).addClass('lastRow');
                } else {
                    $productItems.slice(0 - $modulus).addClass('lastRow');
                }
            }
        });
    })();

	// ---------------------------------------------------------------------
	// | cart                                                              |
	// ---------------------------------------------------------------------

    function updateCartBase() {
        var itemData = [];
        $('*[name*=quantity__]').each(function () {
            var aCartItem = {};
            aCartItem.LineItemId = $(this).attr('name').split('__')[1];
            aCartItem.Quantity = $(this).val();

            $installationOption = $('*[name="installation__' + aCartItem.LineItemId + '"]');
            if ($installationOption.length > 0) {
                aCartItem.InstallationOptionSku = $installationOption.val();
            }

            itemData.push(aCartItem);
        });

        itemData = JSON.stringify({ cartItemDetail: itemData });

        $.ajax({
            contentType: 'application/json; charset=utf-8',
            type: 'POST',
            url: '/api/sitecore/cart/UpdateCart',
            data: itemData,
            success: function (response) {
                if (response.Status == '200' && response.CartPageUrl != '') {
                    window.location = response.CartPageUrl;
                }
            },
            error: function (xhr, errorType) {
                if (xhr.status == '412') {
                    // Invalid cart Item quantity
                    $('#cartErrorMessage').html('<ul><li>' + xhr.statusText + '</li></ul>');
                    $('#cartErrorMessage').show();
                }
            },
            failure: function (response) {
                // TODO: need an error message placeholder
                // $('#result').html(response);\

            }
        });
    }

    (function () {
        $('.btnProceedCheckout').on('click', function (e) {
            var giftCardPostage = $('input[name=GiftCardPostageSelected]');
            if (giftCardPostage.length > 0) {
                e.preventDefault();
                var selectedPostItemCode = $('input[name=GiftCardPostageSelected]:checked');
                var btn = $(this);
                if (selectedPostItemCode.val() == undefined) {
                    $('#selectPostageMessage').removeClass('hidden');
                } else {
                    $('#selectPostageMessage').addClass('hidden');
                    $.ajax({
                        type: 'POST',
                        url: '/api/sitecore/cart/AddGiftCardPostage',
                        data: {
                            itemcode: selectedPostItemCode.val()
                        },
                        success: function (response) {
                            if (response.Status == '200') {
                                window.location = btn.attr('href');
                                $('#cannotPurchaseCheckoutMessage').addClass('hidden');
                            } else {
                                $('#cannotPurchaseCheckoutMessage').removeClass('hidden');
                                e.preventDefault();
                            }
                        }
                    });
                }
            }
        });
    })();

    (function () {
        function enableButton() {
            $('#btnContinueToPayment').attr({
                disabled: null,
                title: 'Continue to Payment'
            });
        }
        $('.formDetails .shipNewAddress').on('ifChecked', function (event) {
            $('.formDetails .newAddress').slideDown(200);
            if ($('#FavoriteDealerPostcode').val() != '') {
                enableButton();
            }
        });
        $('.formDetails .shipSameAddress').on('ifChecked', function (event) {
            $('.formDetails .newAddress').slideUp(200);
            if ($('#FavoriteDealerPostcode').val() != '') {
                enableButton();
            }
        });

        // enable/disable paypal payment button
        $('#chkPayPalTerms').on('ifChecked', function (event) {
            $('#btnCheckoutWithPayPal').removeClass('disabled');
        });
        $('#chkPayPalTerms').on('ifUnchecked', function (event) {
            $('#btnCheckoutWithPayPal').addClass('disabled');
        });

        // ----------------------------------------------------------------
        // | 3DS authentication BEGIN                                       |
        // ----------------------------------------------------------------

        function fetchAccountData(cardholderInfo)
        {            
            return new Promise(function(resolve, reject) {

                $.ajax({
                    type: 'GET',
                    url: '/api/sitecore/payment/GenerateAccountData',
                    success: function (accountDataResponse) {                        
                        var response = new Object();
                        response = JSON.parse(accountDataResponse);
                        response.cardholderInfo = cardholderInfo;                        
                        response.threeDSInfo = { "threeDSReqAuthMethodInd": "01" };
                                            
                        resolve(function () {
                            $('.3dsiframe').show();
                            $.magnificPopup.close();
                            return response;
                        });
                    },
                    error: function (xhr, errorType, errorThrown) {
                        reject (new Error('get account data error: ' + errorThrown));
                    }
                });
            });
        }

        function generateAuthorization(paymentForm)
        {
            try
            {
                var cardholderInfo = new Object();
                cardholderInfo.cardNumber = $('[name="EPS_CARDNUMBER"]').val();
                cardholderInfo.cardExpiryMonth = $('[name="EPS_EXPIRYMONTH"]').val();
                cardholderInfo.cardExpiryYear = $('[name="EPS_EXPIRYYEAR"]').val().slice(-2);
                cardholderInfo.cardholderName = $('[name="EPS_CARDNAME"]').val();

                var promptAutenticationError = function () {
                    //show warning message                
                    $('.js3dsPrompt').show();
                    //reset the form submit element
                    $('#checkoutTerms').prop('checked', false);
                    $('.jsCheckoutForm .formPayment .btnPayment').removeClass('btnClicked');
                  
                }

                var onThreeDSErrorCallback = function (result) {
                    $('.js3dsPrompt').hide();
                    $('.3dsiframe').hide();

                    if (result.errors[0].code == "517" || result.errors[0].code == "504" || result.errors[0].code == "180")
                    {
                        promptAutenticationError();
                    }
                    else
                    {
                        $.magnificPopup.open({
                            items: {
                                src: '#paymentPrompt-popup',
                                type: 'inline'
                            },
                            closeBtnInside: false

                        });
                        paymentForm.submit();
                    }
                    
                }

                var onThreeDSResultsResponseCallback = function (result) {
                    $('.js3dsPrompt').hide();
                    $('.3dsiframe').hide();

                    if ((result.transStatus == "Y" && (result.cardDescription == "Mastercard" || result.cardDescription == "Visa"))
                        || (result.transStatus == "A" && (result.eci == "01" || result.ci == "06"))) {

                        $.magnificPopup.open({
                            items: {
                                src: '#paymentPrompt-popup',
                                type: 'inline'
                            },
                            closeBtnInside: false

                        });
                        paymentForm.submit();
                    }
                    else {
                        promptAutenticationError();
                    }
                }

                fetchAccountData(cardholderInfo).then(function (datafunction) {

                    $.ajax({
                        contentType: 'application/json; charset=utf-8',
                        type: 'GET',
                        url: '/api/sitecore/payment/GenerateAuthorization',
                        success: function (response) {
                            var obj = JSON.parse(response);

                            var sp3dsConfig = {
                                clientId: obj.threedSecure.providerClientId,
                                iframe: document.getElementById("3ds-v2-challenge-iframe"),
                                token: obj.orderToken,
                                simpleToken: obj.simpleToken,
                                threeDSSessionId: obj.threedSecure.sessionId,
                                onRequestInputData: datafunction,
                                onThreeDSResultsResponse: onThreeDSResultsResponseCallback,
                                onThreeDSError: onThreeDSErrorCallback
                            };

                            securePayThreedsUI.initAndStartThreeDS(sp3dsConfig);
                        },
                        error: function (xhr, errorType) {
                            console.log('3ds response error');
                            paymentForm.submit();
                        },
                        failure: function (response) {
                            console.log('3ds response failure');
                            paymentForm.submit();
                        }

                    })
                });
            }
            catch(error)
            {
                paymentForm.submit();
            }
        }

        // ----------------------------------------------------------------
        // | 3DS authentication END                                       |
        // ----------------------------------------------------------------
        

        function verifyOrder(callback) {
            var orderId = "";
            var orderIdInput = $("input[name='EPS_REFERENCEID']");
            if (orderIdInput.length > 0)
                orderId = orderIdInput.val();
            $.ajax({
                contentType: 'application/json; charset=utf-8',
                type: 'GET',
                url: '/api/sitecore/payment/VerifyOrder?orderId=' + orderId,
                success: function (response) {
                    console.log('process-' + response.proceed);
                    console.log('target-' + response.target);
                    callback(response.proceed, response.target);
                },
                error: function (xhr, errorType) {
                    callback(false, 'errorpage');
                },
                failure: function (response) {
                    console.log('process-' + response.proceed);
                    console.log('target-' + response.target);
                    callback(false, 'errorpage');
                }
            });
        }

        $('a.btnPayment').click(function (e) {
            e.preventDefault();
            var failedUrl = $(this).data('axfailedurl');
            var successUrl = $(this).attr('href');

            verifyOrder(function (proceed, target) {
                if (proceed) {
                    window.location = successUrl;
                } else if (target == 'cartpage') {
                    window.location = '/cart';
                }
                else {
                    window.location = failedUrl;
                }
            });
        });
		           
        $('form.paymentForm').on('keydown', 'input', function (event) {
            // Check if the key is Enter and the target is not a submit button
            if (event.key === 'Enter' && $(event.target).attr('type') !== 'submit') {
                event.preventDefault(); // Prevent form submission
            }
        });

		$('form.paymentForm').submit(function (e) {

		    var form = this;		  

		    if (!$(this).valid()) {
		    	return false;
		    }
		    e.preventDefault();

		    var failedUrl = $(this)
		    	.find('#axFailedUrl')
		    	.val();
		               	    
		    $.magnificPopup.open({
		        items: {
		            src: '#paymentPrompt-popup',
		            type: 'inline'
		        },
		        closeBtnInside: false

		    });		  

			verifyOrder(function(proceed, target) {
			    if (proceed) {			        
			        //call 3DS if tag exist
			        if ($('.Enable3dsTag').length) {
			            $('.js3dsPrompt').hide();
			            generateAuthorization(form);
			        }
			        else
			        {
			            form.submit();
			        }
				} else if (target == 'cartpage') {
					window.location = '/cart';
				}
				else {
					window.location = failedUrl;
				}
			});
		});
	})();

	// formValidation();

	// google autocomplete address
	(function () {
		if ($('#BillingAddress').length) {
			$('#BillingAddress').keyup(function () {
				$('#typedBillingAddress').val(this.value);
			});

			var _autoCompleteBillingForm = new google.maps.places.Autocomplete(
				document.getElementById('BillingAddress'), {
				    types: ['geocode'],
				    componentRestrictions: { country: $('.jsAccountForm').data('country') }
				}
			);

            // building up billing details
            google.maps.event.addListener(_autoCompleteBillingForm, 'place_changed', function () {
                var $result = _autoCompleteBillingForm.getPlace();
                var $billingAddress = '';
                var $resultAdressComponents = _autoCompleteBillingForm.getPlace().address_components;
                var suburbFound = false;

                if ($result.address_components != null) {
                    $('#BillingSuburb').val(''); //clear the previous value first since there is possible the current address has no suburb				    
                    for (var i = 0; i < $result.address_components.length; i++) {
                        for (var j = 0; j < $result.address_components[i].types.length; j++) {
                            // building up adddress
                            if ($result.address_components[i].types[j] == 'subpremise') {
                                $billingAddress = $result.address_components[i].long_name + '/';
                            }
                            if ($result.address_components[i].types[j] == 'street_number') {
                                $billingAddress = $billingAddress + $result.address_components[i].long_name;
                            }
                            if ($result.address_components[i].types[j] == 'route') {
                                $billingAddress = $billingAddress + ' ' + $result.address_components[i].long_name;
                            }

                            // removing first empty string
                            if ($('#BillingAddress').length) {
                                $('#BillingAddress').val($billingAddress);
                            } else {
                                $('#txtBillingAddress').val($billingAddress);
                            }
                            // country
                            if ($result.address_components[i].types[j] == 'country') {
                                $('#BillingCountry')
                                    .val($result.address_components[i].long_name)
                                    .trigger('change');
                            }
                            // state
                            if ($('.jsAccountForm').data('country') == "AU") {
                                if ($result.address_components[i].types[j] == 'administrative_area_level_1') {
                                    $('#cboStateBilling')
                                        .val($result.address_components[i].short_name)
                                        .trigger('change');
                                }
                            }
                            // suburb				            
                            if ($('.jsAccountForm').data('country') == "AU") {
                                if ($result.address_components[i].types[j] == 'locality') {
                                    suburbFound = true;
                                    $('#BillingSuburb').val($result.address_components[i].long_name);
                                }
                            } else {
                                if ($result.address_components[i].types[j] == 'sublocality_level_1') {
                                    suburbFound = true;
                                    $('#BillingSuburb').val($result.address_components[i].long_name);
                                }
                            }
                            // postcode
                            if ($result.address_components[i].types[j] == 'postal_code') {
                                $('#BillingPostcode').val($result.address_components[i].long_name);
                            }
                        }
                    }


                    //certain Google NZ address json, subrub is in "types" : [ "locality", "political" ] instead
                    if (!suburbFound && $('.jsAccountForm').data('country') != "AU") {
                        $('#BillingSuburb').val(getSpecialNZSuburb($result.address_components));
                    }
                }

                if ($('#typedBillingAddress').length && $('#BillingAddress').length) {
                    var typedUnitStreetNumber = $('#typedBillingAddress').val().split(' ')[0];
                    var googleUnitStreetNumber = $('#BillingAddress').val().split(' ')[0];

                    if (!googleUnitStreetNumber.toUpperCase().includes(typedUnitStreetNumber.toUpperCase())) {
                        $('#BillingAddress').val($('#BillingAddress').val().replace(googleUnitStreetNumber, typedUnitStreetNumber));
                    }
                }
            });
        }

        if ($('#ShippingAddress').length) {
            $('#ShippingAddress').keyup(function () {
                $('#typedShippingAddress').val(this.value);
            });

            var _autoCompleteShippingForm = new google.maps.places.Autocomplete(
				document.getElementById('ShippingAddress'), {
				    types: ['geocode'],
				    componentRestrictions: { country: $('.jsAccountForm').data('country') }
				}
			);

            // building up shipping details
            google.maps.event.addListener(_autoCompleteShippingForm, 'place_changed', function () {
                var $result = _autoCompleteShippingForm.getPlace();
                var $shippingAddress = '';
                var suburbFound = false;
                $('#ShippingSuburb').val(''); //clear the previous value first since there is possible the current address has no suburb if it is NZ address

                for (var i = 0; i < $result.address_components.length; i++) {
                    for (var j = 0; j < $result.address_components[i].types.length; j++) {
                        // building up adddress
                        if ($result.address_components[i].types[j] == 'subpremise') {
                            $shippingAddress = $result.address_components[i].long_name + '/';
                        }
                        if ($result.address_components[i].types[j] == 'street_number') {
                            $shippingAddress = $shippingAddress + $result.address_components[i].long_name;
                        }
                        if ($result.address_components[i].types[j] == 'route') {
                            $shippingAddress = $shippingAddress + ' ' + $result.address_components[i].long_name;
                        }
                        if ($('#ShippingAddress').length) {
                            $('#ShippingAddress').val($shippingAddress);
                        } else {
                            $('#txtShippingAddress').val($shippingAddress);
                        }

                        // country
                        if ($result.address_components[i].types[j] == 'country') {
                            $('#CountryShipping')
								.val($result.address_components[i].long_name)
								.trigger('change');
                        }
                        // state
                        if ($('.jsAccountForm').data('country') == "AU") {
                            if ($result.address_components[i].types[j] == 'administrative_area_level_1') {
                                $('#cboStateShipping')
									.val($result.address_components[i].short_name)
									.trigger('change');
                            }
                        }
                        // suburb
                        if ($('.jsAccountForm').data('country') == "AU") {
                            if ($result.address_components[i].types[j] == 'locality') {
                                suburbFound = true;
                                $('#ShippingSuburb').val($result.address_components[i].long_name);
                            }
                        } else {
                            if ($result.address_components[i].types[j] == 'sublocality_level_1') {
                                suburbFound = true;
                                $('#ShippingSuburb').val($result.address_components[i].long_name);
                            }
                        }
                        // postcode
                        if ($result.address_components[i].types[j] == 'postal_code') {
                            $('#ShippingPostcode').val($result.address_components[i].long_name);
                        }
                    }
                }

                //certain Google NZ address json, subrub is in "types" : [ "locality", "political" ] instead
                if (!suburbFound && $('.jsAccountForm').data('country') != "AU") {
                    $('#ShippingSuburb').val(getSpecialNZSuburb($result.address_components));
                }

                if ($('#typedShippingAddress').length && $('#ShippingAddress').length) {
                    var typedUnitStreetNumber = $('#typedShippingAddress').val().split(' ')[0];
                    var googleUnitStreetNumber = $('#ShippingAddress').val().split(' ')[0];

                    if (!googleUnitStreetNumber.toUpperCase().includes(typedUnitStreetNumber.toUpperCase())) {
                        $('#ShippingAddress').val($('#ShippingAddress').val().replace(googleUnitStreetNumber, typedUnitStreetNumber));
                    }
                }

            });
        }

    }());


    // ---------------------------------------------------------------------
    // | Get NZ suburb from Google API Json                                           |
    // ---------------------------------------------------------------------
	function getSpecialNZSuburb(addressComponent) {
	    var result = "";
        for (var i = 0; i < addressComponent.length; i++) {
            for (var j = 0; j < addressComponent[i].types.length; j++) {
                if (addressComponent[i].types[j] == 'locality') {
                    return addressComponent[i].long_name;
                }
            }
        }

        //take the state as suburb if still not found since suburb is required
        if (result == "")
        {
            for (var i = 0; i < addressComponent.length; i++) {
                for (var j = 0; j < addressComponent[i].types.length; j++) {
                    if (addressComponent[i].types[j] == 'administrative_area_level_1') {
                        return addressComponent[i].long_name;
                    }
                }
            }
        }

        if (result == "")
        {
            return "NZ"  //return default
        }
    }

    // payment forms - credit card
    (function () {
        var $ccPaymentFormWrapper = $('.jsCheckoutForm .formPayment--credit-card');
        var $ccPaymentForm = $('.jsCheckoutForm .formPayment--credit-card form');

        var msgInvalidCreditCard = $ccPaymentFormWrapper.find('.msgInvalidCreditCard').data('msg');
        var msgInvalidCvc = $ccPaymentFormWrapper.find('.msgInvalidCvc').data('msg');
        var msgRequired = $ccPaymentFormWrapper.find('.msgRequired').data('msg');

        var $date = new Date();
        var $month = $date.getMonth() + 1;
        var $year = $date.getFullYear();

        $('.jsCheckoutForm .formPayment .month select').change(function () {
            if ($(this).val() < $month && $('.jsCheckoutForm .formPayment .year select').val() == $year) {
                $('.jsCheckoutForm .formPayment .month').addClass('has-error');
                $('.jsCheckoutForm .formPayment .btnPayment').addClass('disabled');
            } else {
                $('.jsCheckoutForm .formPayment .month').removeClass('has-error');
            }
        });

        $('.jsCheckoutForm .formPayment .year select').change(function () {
            if ($(this).val() == $year && $('.jsCheckoutForm .formPayment .month select').val() < $month) {
                $('.jsCheckoutForm .formPayment .month').addClass('has-error');
                $('.jsCheckoutForm .formPayment .btnPayment').addClass('disabled');
            } else {
                $('.jsCheckoutForm .formPayment .month').removeClass('has-error');
            }
        });

        $('#checkoutTerms').on('ifChanged', function (event) {
            $(event.target).trigger('change');
            if ($(this).is(":checked")) {
                $('.jsCheckoutForm .formPayment .btnPayment').removeClass('disabled');
            } else {
                $('.jsCheckoutForm .formPayment .btnPayment').addClass('disabled');
            }
        });

        $ccPaymentForm.validate({
            errorClass: 'field-validation-error',
            errorPlacement: function (error, element) {
                if (element.is('select') || element.is('input[type="checkbox"]') || element.is('input[type="radio"]')) {
                    error.appendTo(element.parents('.form-group'));
                } else {
                    error.insertAfter(element);
                }
            },
            rules: {
                EPS_CARDNUMBER: {
                    required: true,
                    creditcard: true
                },
                EPS_CCV: {
                    required: true,
                    number: true
                }
            },
            messages: {
                EPS_CARDNUMBER: {
                    creditcard: msgInvalidCreditCard
                },
                EPS_CCV: {
                    minlength: msgInvalidCvc,
                    maxlength: msgInvalidCvc
                }
            }
        });

        $.validator.messages.required = function (param, input) {
            return msgRequired;
        };

    }());

    // payment forms - gift card
    (function () {
        var $gcPaymentFormWrapper = $('.jsCheckoutForm .formPayment--gift');
        var $gcPaymentForm = $('.jsCheckoutForm .formPayment--gift form');

        var msgRequired = $gcPaymentFormWrapper.find('.msgRequired').data('msg');

        // hide the gift card tab by default and only show if not purchasing gift card(s)
        var $giftCardTab = $('#tab-3');
        if ($giftCardTab.length > 0 && $giftCardTab[0].children.length > 0) {
            $('ul.tabList--checkout li.tabListItemGiftCard').show();
        }

        $gcPaymentForm.validate({
            errorClass: 'field-validation-error',
            errorPlacement: function (error, element) {
                if (element.is('select') || element.is('input[type="checkbox"]') || element.is('input[type="radio"]')) {
                    error.appendTo(element.parents('.form-group'));
                } else {
                    error.insertAfter(element);
                }
            },
            rules: {
                gcNumber: {
                    required: true,
                    number: true
                },
                gcPin: {
                    required: true,
                    number: true
                }
            }
        });

        $.validator.messages.required = function (param, input) {
            return msgRequired;
        };

    }());

    $('.jsContinueShopping').on('click', function () {

        var categoryLink = localStorage.getItem("lastProductCategory");

        if (categoryLink) {
            window.location = categoryLink;
        }
        else {
            window.location = $(this).attr("href");
        }
        event.preventDefault();
    });

    // ---------------------------------------------------------------------
    // checkout                                                            |
    // ---------------------------------------------------------------------

    // display gift card tab when error occured
    (function () {
        // hacky check that displays the gift card tab when it postbacks an error
        if ($('.jsGiftCardError').length && $('.jsTabsCheckout').length) {
            $('.jsTabsCheckout .tabListItem').removeClass('active').attr('style', '');
            $('.jsTabsCheckout .tabContentItem').removeClass('active').attr('style', '');
            $('.jsTabsCheckout .tabListItemGiftCard').addClass('active');
            $('.jsTabsCheckout .tabContentItemGiftCard').addClass('active');
        }
    })();

    // ---------------------------------------------------------------------
    // search page                                                         |
    // ---------------------------------------------------------------------

    $('.jsBtnAccessorySearch').on('click', function () {
        window.location.href = updateQueryStringParameter(window.location.href, 'category', '');
    });

    $('.jsBtnContentSearch').on('click', function () {
        window.location.href = updateQueryStringParameter(window.location.href, 'category', 'content');
    });

    // ---------------------------------------------------------------------
    // print button                                                        |
    // ---------------------------------------------------------------------

    $('.jsBtnPrint').on('click', function () {
        window.print();
    });

    // ---------------------------------------------------------------------
    // | form validation                                                   |
    // ---------------------------------------------------------------------

    // login, registration, update password, update address

    window.formValidation = function () {
        var $formWrapper = $('.jsAccountForm');
        var $form = $formWrapper.find('form');
        var $passwordField = $form.find('input[name="newpassword"]');

        var msgInvalidEmail = $formWrapper.find('.msgInvalidEmail').data('msg');
        var msgInvalidPhone = $formWrapper.find('.msgInvalidPhone').data('msg');
        var msgInvalidBillingPostcode = $formWrapper.find('.msgInvalidBillingPostcode').data('msg');
        var msgInvalidShippingPostcode = $formWrapper.find('.msgInvalidShippingPostcode').data('msg');
        var msgPasswordTooShort = $formWrapper.find('.msgPasswordTooShort').data('msg');
        var msgFailedPasswordMatch = $formWrapper.find('.msgFailedPasswordMatch').data('msg');
        var msgRequired = $formWrapper.find('.msgRequired').data('msg');

        $('#ShipToShipping').on('ifChanged', function (event) {
            $(event.target).trigger('change');
            $('.jsShippingWrapper').slideToggle();
        });

        // separate products checklist validation
        if ($('.jsAccountForm .jsSubscriptionList').length) {
            $('#formRegistration').submit(function () {
                if ($('#ShipToBilling').iCheck('update')[0].checked == true) {
                    $('#ShippingFirstName').val($('#BillingFirstName').val());
                    $('#ShippingLastName').val($('#BillingLastName').val());
                    $('#ShippingCompany').val($('#BillingCompany').val());
                    $('#ShippingPhone').val($('#BillingPhone').val());
                    $('#ShippingFax').val($('#BillingFax').val());
                    $('#ShippingAddress').val($('#BillingAddress').val());
                    $('#ShippingSuburb').val($('#BillingSuburb').val());
                    $('#ShippingPostcode').val($('#BillingPostcode').val());

                    if ($('#cboStateBilling').length > 0 && $('#cboStateShipping').length > 0)
                        $('#cboStateShipping').val($('#cboStateBilling').val());

                    $('#cboCountryShipping').val($('#cboCountryBilling').val()).change();

                    //// copy state - requires country to be set first
                    //var checkForCountry = function() {
                    //    var countryIsSet = $('#cboCountryShipping').val() !== '' && $('#cboCountryShipping').val() !== null;


                    //    console.log('isI:' + countryIsSet);


                    //	if (countryIsSet) {
                    //		$('#cboStateShipping').val($('#cboStateBilling').val()).change();
                    //		$('#cboStateShipping').prop('disabled', true);
                    //		clearInterval(timer);
                    //		return;
                    //	}
                    //};

                    //var timer = setInterval(checkForCountry, 500);
                }

                // t&c checkbox not checked
                if (!$('#termAndConditionCheckbox').is(':checked') && $('#termAndConditionCheckbox').is(':visible')) {
                    $('#termandcondition-error').css('display', 'inline-block');
                    $('#formSubmitButton').removeClass('btnClicked');
                    return false;
                } else {
                    $('#termandcondition-error').hide();
                }
                // products checkboxes not checked
                if (!$('.jsAccountForm .jsSubscriptionList input[type="checkbox"]').is(':checked') && $('.jsAccountForm .jsSubscriptionList').is(':visible')) {
                    $('#products-error').css('display', 'inline-block');
                    $('#formSubmitButton').removeClass('btnClicked');
                    return false;
                } else {
                    $('#products-error').hide();
                }
                if (!$('.has-error').length) {
                    $('.registrationForm #formSubmitButton').addClass('btnClicked');
                }
            });
        }

        //form using invisible ReCaptcha
        if ($('.jsInvsReCaptchaForm').length) {
            $('.jsInvsReCaptchaForm').submit(function () {
                $('#formSubmitButton').addClass('btnClicked');

                //get policy Regex if apply, then perform validation
                if ($('.policyNoRegEx').length && $('.policyNoRegEx').val() != '') {
                    var re = $('.policyNoRegEx').val();

                    if ($('#ReferenceNumber').length && $('#ReferenceNumber').val() != '' && $('#ReferenceNumber').val().match(new RegExp(re)) == null) {
                        console.log($('#ReferenceNumber').val().match(new RegExp(re)));
                        $('#policy-error').css('display', 'inline-block');
                        $('#formSubmitButton').removeClass('btnClicked');
                        return false;
                    }
                    else {
                        $('#policy-error').hide();
                    }
                }


                if (!$('#termAndConditionCheckbox').is(':checked') && $('#termAndConditionCheckbox').is(':visible')) {
                    $('#termandcondition-error').css('display', 'inline-block');
                    $('#formSubmitButton').removeClass('btnClicked');
                    return false;
                } else {
                    $('#termandcondition-error').hide();
                }
            });
        }

        $form.validate({
            errorClass: 'field-validation-error',
            errorPlacement: function (error, element) {
                if (element.is('select') || element.is('input[type="checkbox"]') || element.is('input[type="radio"]')) {
                    error.appendTo(element.parents('.form-group'));
                } else {
                    element.parents('.form-group').addClass('has-error');
                    error.insertAfter(element);
                }
            },
            success: function (label) {
                label.parents('.form-group').removeClass('has-error');
            },
            rules: {
                BillingPhone: {
                    phoneGeneric: true
                },
                // BillingPostcode: {
                // 	postCodeBilling: true
                // },
                ShippingPostcode: {
                    postCode: true
                },
                ShippingPhone: {
                    phoneGeneric: true
                },
                confirmpassword: {
                    equalTo: $passwordField
                },
                confirmbillingemail: {
                    equalTo: $form.find('input[name="billingemail"]')
                },
                confirmshippingemail: {
                    equalTo: $form.find('input[name="shippingemail"]')
                }
            },
            messages: {
                email: {
                    email: msgInvalidEmail
                },
                currentpassword: {
                    minlength: msgPasswordTooShort
                },
                password: {
                    minlength: msgPasswordTooShort
                },
                newpassword: {
                    minlength: msgPasswordTooShort
                },
                confirmpassword: {
                    equalTo: msgFailedPasswordMatch,
                    minlength: msgPasswordTooShort
                }
            },
            invalidHandler: function (event, validator) {
                // when the form is considered invalid, remove the btnClicked class so the user can click the button to resubmit
                setTimeout(function () {
                    $('.registrationForm #formSubmitButton').removeClass('btnClicked');
                }, 500);
            }
        });

        $.validator.messages.required = function (param, input) {
            return msgRequired;
        };

        // $.validator.addMethod('postCodeBilling', function(value) {
        // 	return /^(([0-9\-\(\)\s]+))$/.test(value) && value.length <= 4;
        // }, msgInvalidBillingPostcode);

        $.validator.addMethod('postCode', function (value) {
            var excludedPostcodes = ['0822', '0852', '2083', '2105', '2257', '2898', '2899', '4875', '6044', '6161', '6731', '6733', '6798', '6799', '7151'];
            if ($('#cboCountryShipping').val() == 'AU') {
                return /^(([0-9\-\(\)\s]+))$/.test(value) && $.inArray(value, excludedPostcodes) == -1 && value.length <= 4;
            } else {
                return /^(([0-9\-\(\)\s]+))$/.test(value) && value.length <= 4;
            }
        }, msgInvalidShippingPostcode);

        $.validator.addMethod('phoneGeneric', function (value) {
            if ($('#cboCountryShipping').val() == 'AU') {
                if (!/\s/.test(value)) {
                    return /^(([0-9\-\(\)\s]+))$/.test(value) && value.length >= 10;
                }
            } else {
                if (!/\s/.test(value)) {
                    return /^(([0-9\-\(\)\s]+))$/.test(value);
                }
            }
        }, msgInvalidPhone);
    };

    if ($('.jsAccountForm').length) {
        formValidation();
    }

    if ($('#productTitle').length) {
        document.title = $('#productTitle').text();
    }

    // ---------------------------------------------------------------------
    // | guest checkout validation                                                   |
    // ---------------------------------------------------------------------
    function IsEmail(email) {
        var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!regex.test(email)) {
            return false;
        } else {
            return true;
        }
    }

    if ($('#IsGuestcheckout').length) {
        $('#login-email').focusout(function () {
            if (IsEmail(this.value)) {

                $.ajax({
                    type: "POST",
                    url: '/api/sitecore/account/ValidateEmail',
                    data: { email: this.value },
                    success: function (response) {

                        if (response.status == '200') {
                            //do nothing continue as guest
                            $('#errorMessageSection').addClass('hidden');
                            $('#userRegisterSection .btn').addClass('btnClicked');
                        } else {
                            $('#errorMessageSection').removeClass('hidden');
                            $('#userRegisterSection .btn').removeClass('btnClicked');
                        }
                    }
                });
            }
        });
    }


    $('#errorMessageSection .errorMessageBtn').click(function () {
        $('#errorMessageSection').addClass('hidden');
        $('#userRegisterSection .btn').removeClass('btnClicked');
    });

    //------------------------------
    //data layer functions
    //------------------------------

    //this is not need as there is a data push when viewing product detail page
    //(function () {
    //    var $productLinkClick = $('.jsProductClick');
    //    $productLinkClick.on('click', function (e) {
    //        window.dataLayer = window.dataLayer || [];

    //        //todo: need to remove later once tested
    //        dataLayer.push({
    //            'event': 'productClick',
    //            'ecommerce': {
    //                'click': {
    //                    'actionField': { 'list': 'Product Listing' },
    //                    'products': [e.currentTarget.getAttribute("data-productJson")]
    //                }
    //            }
    //        });

    //    });
    //})();

    (function () {
        var $productLinkClick = $('.jsRemoveItemCart');
        $productLinkClick.on('click', function (e) {
            window.dataLayer = window.dataLayer || [];


            //GA 4	        
            if (typeof productGA4JsonArray !== 'undefined') {
                var productInfojson = productGA4JsonArray.get(e.currentTarget.getAttribute("data-productId"));

                dataLayer.push({
                    'event': 'remove_from_cart',
                    'ecommerce':
                    {
                        'currency': "'" + $('.jsAddToCartCurrencyJson').val() + "'",
                        'value': productInfojson.price,
                        'items': [productInfojson]
                    }
                });

            }
        });
    })();


    (function () {
        if ($('.jsCheckoutStep').length && $('.jscartSummary').length) {
            window.dataLayer = window.dataLayer || [];

            var stepStr = "'" + $('.jsCheckoutStep').attr('data-stepNo') + "'";

            //GA4 checkout event	        

            if ($('.jsCheckoutStep').attr('data-stepNo') == '3') {
                if (typeof productJsonList !== 'undefined') {

                    dataLayer.push({
                        'event': 'begin_checkout',
                        'ecommerce': {
                            'currency': "'" + $('.jsAddToCartCurrencyJson').val() + "'",
                            'value': $('.jsCartTotal').val(),
                            'items': productJsonList
                        }
                    });
                }
            }
        };

    })();

    // ---------------------------------------------------------------------
    // | yshop enquiry modal                                               |
    // ---------------------------------------------------------------------
    (function () {
        const enquiryBtn = document.querySelector('#enquiryBtn');
        const enquiryModal = document.querySelector('#enquiryModal');
        const closeBtn = document.querySelector('#closeBtn');
        const modalOverlayMobile = document.querySelector('#modalOverlay');

        if (enquiryBtn !== null) {
            enquiryBtn.addEventListener('click', function () {
                if (enquiryModal.className.indexOf('modalOpened') === -1) {
                    enquiryModal.classList.toggle('modalOpened');
                    modalOverlayMobile.classList.toggle('overlayOpened');
                }
            });

        }

        if (closeBtn !== null) {
            closeBtn.addEventListener('click', function () {
                if (enquiryModal.className.indexOf('modalOpened') > -1) {
                    enquiryModal.classList.toggle('modalOpened');
                    modalOverlayMobile.classList.toggle('overlayOpened');
                }
            });
        }
    })()
});
